import Vue from 'vue';
import VueRouter from 'vue-router';
import {routers} from './router';

import Util from '../lib/util';
import Cookies from 'js-cookie'
import { appRouters,otherRouters} from './router'

Vue.use(VueRouter);

const RouterConfig = {
    // mode: 'history',
    routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    //iView.LoadingBar.start();
    Util.title(to.meta.title);
    var token =Util.abp.auth.getToken();
    if (Cookies.get('locking') === '1' && to.name !== 'locking') {
        next({
            replace: true,
            name: 'locking'
        });
    }else if (Cookies.get('locking') === '0' && to.name === 'locking') {
        next(false);
    } else {
        if (!token&& to.name !== 'login') {
            next({
                name: 'login'
            });
        } else if (!!token&& to.name === 'login') {
            Util.title(to.meta.title);
            next({
                name: 'flightReservationMonitor'
            });
        } else if (!!token&& (to.name === 'home' || to.name === 'main')) {
            next({
                name: 'flightReservationMonitor'
            });
        } else {
            const curRouterObj = Util.getRouterObjByName([otherRouters, ...appRouters], to.name);
            if (curRouterObj && curRouterObj.permission) {
                if (window.abp.auth.hasPermission(curRouterObj.permission)) {
                    Util.toDefaultPage([otherRouters, ...appRouters], to.name, router, next);
                } else {
                    next({
                        replace: true,
                        name: 'error-403'
                    });
                }
            } else {
                Util.toDefaultPage([...routers], to.name, router, next);
            }
        }
    }
});
router.afterEach((to) => {
    Util.openNewPage(router.app, to.name, to.params, to.query);
  // iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});